import React, { useEffect, useState } from "react";
import styles from "./SplashScreen.module.css";

interface SplashScreenProps {
  onComplete: () => void;
}

const SplashScreen: React.FC<SplashScreenProps> = ({ onComplete }) => {
  const [isFadingOut, setIsFadingOut] = useState(false);

  useEffect(() => {
    // 페이드인 + 표시 시간 후 페이드아웃 시작
    const startFadeOutTimer = setTimeout(() => {
      setIsFadingOut(true);
    }, 2000); // 애니메이션 GIF를 더 오래 보여주기 위해 시간 증가

    // 페이드아웃 완료 후 콜백 호출
    const completeTimer = setTimeout(() => {
      onComplete();
    }, 2400); // 페이드아웃 시간도 맞춰서 조정

    return () => {
      clearTimeout(startFadeOutTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div
      className={`${styles.splashScreen} ${isFadingOut ? styles.fadeOut : ""}`}
    >
      <img
        src={`${process.env.PUBLIC_URL}/images/assets/splash_logo_1.png`}
        alt="PetMilly Splash"
        className={styles.splashLogo}
      />
      <div className={styles.splashText}>
        <h3>펫밀리</h3>
        <span>
          반려의 시작부터 마지막까지,
          <br />
          감정을 기록하는 곳
        </span>
      </div>
    </div>
  );
};

export default SplashScreen;
